module.exports = __webpack_public_path__ + "static/media/linea_2.9c612e73.svg";